import { render, staticRenderFns } from "./department_edit.vue?vue&type=template&id=2c978608&"
import script from "./department_edit.vue?vue&type=script&lang=js&"
export * from "./department_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports